import React,{useEffect, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import {Link} from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useDispatch, useSelector } from 'react-redux';
import { asyncSignin } from '../../redux/ducks/userDuck';
import {history, MyMess} from '../../App';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import { LinearProgress } from '@material-ui/core';
import {isEmail} from '../../utils/Utils';
import { info, error, defaults } from '@pnotify/core';
import * as Confirm from "@pnotify/confirm";
import '@pnotify/core/dist/PNotify.css';
import "@pnotify/core/dist/BrightTheme.css";
import loginImage from '../../images/Login.png'
import logoImage from '../../images/logo.png'

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import {GreenButton} from '../../component/colorButton';
import LangChangeSelect from '../../component/LangChangeSelect';
import Footer from '../../component/footer';
import Hidden from '@material-ui/core/Hidden';
import {Alert} from '@material-ui/lab';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: '100vh'
  },
  paper: {
    position:'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  landingImage: {
    flex: 1,
    position: 'relative'
  },
  logo: {
    width: '60%'
  },
  cardRoot: {
    minWidth: 345,
    maxWidth: 345,
  },
  langPicker: {
    position: 'absolute',
    top: 15,
    right: 15
  },
  floatRight: {
    float: 'right'
  },
  link: {
    color: "#5db4a2",
    '&:visited' :{
      color: "#5db4a2",
    },
  },
  alert: {
    paddingTop: theme.spacing(2),
    clear: 'both'
  }
}));

export default function SignIn() {
  const classes = useStyles();

  let [loginInfo, setLoginInfo] = useState({email:'',password:''})  
  let [isSubmitting, setSubmitting] = useState(false);

  let user = useSelector( state => state.user );
  let app = useSelector(state => state.app);
  MyMess.setLanguage(app.lang);

  let dispatch = useDispatch();

  let [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {

    //console.log('user change?')
    if(user.authorization && user.authorization !== 'invalid'){
      jumpToMain();
    }
    return () => {
      
    }
  }, [])


 
  useEffect(() => {
    
    // const listener = event => {
    //   if (event.code === "Enter" || event.code === "NumpadEnter") {
    //     console.log("Enter key was pressed. Run your function.");
    //     // callMyFunction();
    //     signInClickHandler();
    //   }
    // };
    // document.addEventListener("keydown", listener);
    // return () => {
    //   document.removeEventListener("keydown", listener);
    // };
  }, []);

  const changeHandler = e => {
    setLoginInfo({...loginInfo, [e.target.name]: e.target.value})        
 }

 const signInClickHandler = (e) => {

  if (e) {
    e.preventDefault();
  }

  // if(!isEmail(loginInfo.email)) {
  //   GlobalSnackBarUtil.open({
  //     message:getEmailErrorMsg(),
  //     severity:'error',
  //   })
    
  //   return;
  // } 
  setErrorMessage("");
  setSubmitting(true);
  dispatch(asyncSignin(loginInfo.email, loginInfo.password,signInCallBack))
 }

 const signInCallBack = (data) => {   
   setSubmitting(false);
   setLoginInfo({email:'',password:''});   

    if (data.headers && data.headers['expiry-alert'] && data.headers['expiry-alert'] === 'true') {
      info({
        title: MyMess.domains.alerts.expiry.title,
        text: MyMess.domains.alerts.expiry.message,
        hide: false,
        modules: new Map([
          [
            Confirm,
            {
              confirm: true,
              buttons: [
                {
                  text: MyMess.general.confirm,
                  primary: true,
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          ]
        ])
      })
    }

   if(data.data && data.data.pass) {
     
    jumpToMain();

     
   } else {
    setErrorMessage(MyMess.general.loginFailed);
   }
 }

 const isFormValid = () => {

 }

 const isEmailError = () => {

    if (loginInfo.email && !isEmail(loginInfo.email)) {
      return true;
    }

    return false;
 }

 const getEmailErrorMsg = () => {
    if(isEmailError()) {
        return MyMess.general.errors.email;
    }
    return '';
 }

 const showErrorMsg = () => {
    if (errorMessage) {
      return <div className={classes.alert}><Alert  severity="error">{errorMessage}</Alert></div>;
    }

    return null;
 }

  const jumpToMain= () => {
    let redirectParam = '/main';
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('redirect');
    console.log(myParam);
    if(myParam){
      redirectParam = myParam;      
    }
    if(redirectParam && redirectParam.startsWith('/main')){
      history.push(redirectParam); 
    }else{
      history.push('/main');  
    }
  }


 const formComponent = () => {
   return (
    <form className={classes.form}  onSubmit={signInClickHandler.bind(this)}   >
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="email"
        inputProps={{ style: { textTransform: "lowercase" } }}
        label={MyMess.general.emailAddress}
        name="email"
        autoComplete="email"
        autoFocus
        value={loginInfo.email}
        onChange={changeHandler}
        disabled={isSubmitting}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="password"
        label={MyMess.general.password}
        type="password"
        id="password"
        value={loginInfo.password}
        autoComplete="current-password"
        onChange={changeHandler}
        disabled={isSubmitting}
      />
      {/* <FormControlLabel
        control={<Checkbox value="remember" color="primary" />}
        label="Remember me"
        disabled={isSubmitting}
      /> */}
      <Link to="/forgetPw" variant="body2" className={`${classes.floatRight} ${classes.link}`}>
        {MyMess.general.forgotPassword}
      </Link>
      {showErrorMsg()}
      <GreenButton
        type='submit'            
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
        // onClick={signInClickHandler}
      >
        {MyMess.general.signIn}
      </GreenButton>
      <Grid container justify="center">
        <Grid item>
          <Link to="/signupform" variant="body2" className={classes.link}>
            {MyMess.general.noAccount}
          </Link>
        </Grid>
      </Grid>
    </form>
   )
 }

  return (    
    <div>
      <div className="s">
        <div className="a"></div>
        <div className="b"></div>
        <div className="c"></div>
        <div className="d"></div>
      </div>
      <div className={classes.langPicker}>
        <LangChangeSelect variant="" />
      </div>
      <Container component="main" className={classes.root} maxWidth="xl">
        {isSubmitting  && <LinearProgress />}
        <CssBaseline />
        <div className={classes.paper}>
 
          <Card className={classes.cardRoot} raised={true}>
            <CardHeader
              title={<img src={logoImage} className={classes.logo}/>}
            />
            <CardContent>
              <Typography component="h5" variant="h5">
                {MyMess.general.signIn}
              </Typography>
            {formComponent()}
            </CardContent>
          </Card>
        </div>
        <Hidden only={['xs', 'sm']}>
          <div className={classes.landingImage}>
            <img src={loginImage}  />
          </div>
        </Hidden>
        
      </Container>
      <Footer />
       
    </div>
  );
}
